export default __webpack_public_path__ + "static/media/07.b1ee371e.jpg";